<div class="checkboxbutton-wrapper" [formGroup]="form">
	<input class="{{class}}" (change)="updateModel($event)" [formControlName]="name" [value]="value" type="checkbox" [name]="name" [id]="name" [required]="required" [checked]="model == value" [attr.aria-checked]="model == value? 'true' : 'false'">
	<label [for]="name"><span [innerHTML]="label"></span></label>
</div>
